var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "128px",
    height: "128px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 30.5,
    width: 13,
    height: 13,
    fill: "#ff1647"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#cc1138;#ff1647;#ff1647",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 30.5,
    width: 13,
    height: 13,
    fill: "#ff1647"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#cc1138;#ff1647;#ff1647",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.125s",
    calcMode: "discrete"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 30.5,
    width: 13,
    height: 13,
    fill: "#ff1647"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#cc1138;#ff1647;#ff1647",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.25s",
    calcMode: "discrete"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 43.5,
    width: 13,
    height: 13,
    fill: "#ff1647"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#cc1138;#ff1647;#ff1647",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.875s",
    calcMode: "discrete"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 43.5,
    width: 13,
    height: 13,
    fill: "#ff1647"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#cc1138;#ff1647;#ff1647",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.375s",
    calcMode: "discrete"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 56.5,
    width: 13,
    height: 13,
    fill: "#ff1647"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#cc1138;#ff1647;#ff1647",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.75s",
    calcMode: "discrete"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 56.5,
    width: 13,
    height: 13,
    fill: "#ff1647"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#cc1138;#ff1647;#ff1647",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.625s",
    calcMode: "discrete"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 56.5,
    width: 13,
    height: 13,
    fill: "#ff1647"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#cc1138;#ff1647;#ff1647",
    keyTimes: "0;0.125;1",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.5s",
    calcMode: "discrete"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.a4f298f7e5994a475689ecefbacb8575.svg";
export { ForwardRef as ReactComponent };